import React from 'react';

import { config } from '@/config.ts';

interface FlagProps {
	lang: string;
}

const isSk2 = config.BRAND === 'sk2';
const isCom2 = config.BRAND === 'com2';

const isHiddenRuFlag = isSk2 || isCom2;

const Ru: React.FC = () => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<mask id='mask0_2015_4068' maskUnits='userSpaceOnUse' x='0' y='4' width='24' height='16'>
			<path
				d='M22 4H2C0.895431 4 0 4.89543 0 6V18C0 19.1046 0.89543 20 2 20H22C23.1046 20 24 19.1046 24 18V6C24 4.89543 23.1046 4 22 4Z'
				fill='white'
			/>
		</mask>
		<g mask='url(#mask0_2015_4068)'>
			<path
				d='M2 4.5H22C22.8284 4.5 23.5 5.17157 23.5 6V18C23.5 18.8284 22.8284 19.5 22 19.5H2C1.17157 19.5 0.5 18.8284 0.5 18V6C0.5 5.17157 1.17157 4.5 2 4.5Z'
				fill='white'
				stroke='#F0F0F0'
			/>
			<path d='M24 9.33337H0V14.6667H24V9.33337Z' fill='#0C47B7' />
			<path d='M24 14.6666H0V20H24V14.6666Z' fill='#E53B35' />
		</g>
	</svg>
);

const RuNoFlag: React.FC = () => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect y='4' width='24' height='16' rx='2' fill='#418FDE'></rect>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M11.6846 16.8991C11.7889 16.9057 11.894 16.9091 12 16.9091C12.106 16.9091 12.2111 16.9057 12.3154 16.8991C13.0645 16.0119 13.545 14.3856 13.6246 12.5455H10.3754C10.455 14.3856 10.9355 16.0119 11.6846 16.8991ZM10.1858 16.563C9.65395 15.4797 9.34323 14.0684 9.28338 12.5455H7.12087C7.32339 14.3775 8.53407 15.9057 10.1858 16.563ZM11.6846 7.10088C10.9355 7.9881 10.455 9.61442 10.3754 11.4545H13.6246C13.545 9.61442 13.0645 7.9881 12.3154 7.10088C12.2111 7.09427 12.106 7.09091 12 7.09091C11.894 7.09091 11.7889 7.09427 11.6846 7.10088ZM10.1858 7.43702C8.53407 8.0943 7.32339 9.6225 7.12087 11.4545H9.28338C9.34323 9.93161 9.65395 8.52031 10.1858 7.43702ZM13.8142 16.563C15.4659 15.9057 16.6766 14.3775 16.8791 12.5455H14.7166C14.6568 14.0684 14.346 15.4797 13.8142 16.563ZM13.8142 7.43702C14.346 8.52031 14.6568 9.93161 14.7166 11.4545H16.8791C16.6766 9.6225 15.4659 8.0943 13.8142 7.43702ZM12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18Z'
			fill='white'
		></path>
	</svg>
);

const Kz: React.FC = () => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M22 4H2C0.895431 4 0 4.89543 0 6V18C0 19.1046 0.89543 20 2 20H22C23.1046 20 24 19.1046 24 18V6C24 4.89543 23.1046 4 22 4Z'
			fill='#30C6E0'
		/>
		<path
			d='M11.9999 15.2C13.8934 15.2 15.4284 13.7674 15.4284 12C15.4284 10.2327 13.8934 8.80005 11.9999 8.80005C10.1063 8.80005 8.57129 10.2327 8.57129 12C8.57129 13.7674 10.1063 15.2 11.9999 15.2Z'
			fill='#FFCD4B'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M12.0001 15.7709L10.6014 17.7195L10.2471 15.3974L8.08099 16.5867L8.84128 14.3511L6.33684 14.5454L8.06113 12.8391L5.71436 12L8.06113 11.1609L6.33684 9.45452L8.84128 9.64886L8.08099 7.41323L10.2471 8.60252L10.6014 6.2804L12.0001 8.22908L13.3988 6.2804L13.7531 8.60252L15.9191 7.41323L15.1589 9.64886L17.6633 9.45452L15.939 11.1609L18.2858 12L15.939 12.8391L17.6633 14.5454L15.1589 14.3511L15.9191 16.5867L13.7531 15.3974L13.3988 17.7195L12.0001 15.7709ZM12.0001 15.7333C14.2092 15.7333 16.0001 14.0618 16.0001 12C16.0001 9.93811 14.2092 8.26664 12.0001 8.26664C9.79093 8.26664 8.00007 9.93811 8.00007 12C8.00007 14.0618 9.79093 15.7333 12.0001 15.7333Z'
			fill='#FFCD4B'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M1.14258 5.33582C1.14258 5.18716 1.26488 5.06665 1.43097 5.06665H1.99704C2.15632 5.06665 2.28544 5.1808 2.28544 5.33582V5.86415C2.28544 6.01281 2.16313 6.13332 1.99704 6.13332H1.43097C1.2717 6.13332 1.14258 6.01917 1.14258 5.86415V5.33582ZM1.14258 7.46915C1.14258 7.32049 1.26488 7.19998 1.43097 7.19998H1.99704C2.15632 7.19998 2.28544 7.31414 2.28544 7.46915V7.99749C2.28544 8.14614 2.16313 8.26665 1.99704 8.26665H1.43097C1.2717 8.26665 1.14258 8.1525 1.14258 7.99749V7.46915ZM1.14258 9.60248C1.14258 9.45383 1.26488 9.33332 1.43097 9.33332H1.99704C2.15632 9.33332 2.28544 9.44747 2.28544 9.60248V10.1308C2.28544 10.2795 2.16313 10.4 1.99704 10.4H1.43097C1.2717 10.4 1.14258 10.2858 1.14258 10.1308V9.60248ZM1.14258 11.7358C1.14258 11.5872 1.26488 11.4667 1.43097 11.4667H1.99704C2.15632 11.4667 2.28544 11.5808 2.28544 11.7358V12.2642C2.28544 12.4128 2.16313 12.5333 1.99704 12.5333H1.43097C1.2717 12.5333 1.14258 12.4192 1.14258 12.2642V11.7358ZM1.14258 13.8691C1.14258 13.7205 1.26488 13.6 1.43097 13.6H1.99704C2.15632 13.6 2.28544 13.7141 2.28544 13.8691V14.3975C2.28544 14.5461 2.16313 14.6667 1.99704 14.6667H1.43097C1.2717 14.6667 1.14258 14.5525 1.14258 14.3975V13.8691ZM1.14258 16.0025C1.14258 15.8538 1.26488 15.7333 1.43097 15.7333H1.99704C2.15632 15.7333 2.28544 15.8475 2.28544 16.0025V16.5308C2.28544 16.6795 2.16313 16.8 1.99704 16.8H1.43097C1.2717 16.8 1.14258 16.6858 1.14258 16.5308V16.0025ZM1.14258 18.1358C1.14258 17.9872 1.26488 17.8667 1.43097 17.8667H1.99704C2.15632 17.8667 2.28544 17.9808 2.28544 18.1358V18.6642C2.28544 18.8128 2.16313 18.9333 1.99704 18.9333H1.43097C1.2717 18.9333 1.14258 18.8192 1.14258 18.6642V18.1358ZM2.28544 17.0691C2.28544 16.9205 2.40774 16.8 2.57383 16.8H3.1399C3.29918 16.8 3.42829 16.9141 3.42829 17.0691V17.5975C3.42829 17.7461 3.30599 17.8667 3.1399 17.8667H2.57383C2.41455 17.8667 2.28544 17.7525 2.28544 17.5975V17.0691ZM2.28544 14.9358C2.28544 14.7872 2.40774 14.6667 2.57383 14.6667H3.1399C3.29918 14.6667 3.42829 14.7808 3.42829 14.9358V15.4642C3.42829 15.6128 3.30599 15.7333 3.1399 15.7333H2.57383C2.41455 15.7333 2.28544 15.6192 2.28544 15.4642V14.9358ZM2.28544 12.8025C2.28544 12.6538 2.40774 12.5333 2.57383 12.5333H3.1399C3.29918 12.5333 3.42829 12.6475 3.42829 12.8025V13.3308C3.42829 13.4795 3.30599 13.6 3.1399 13.6H2.57383C2.41455 13.6 2.28544 13.4858 2.28544 13.3308V12.8025ZM2.28544 10.6691C2.28544 10.5205 2.40774 10.4 2.57383 10.4H3.1399C3.29918 10.4 3.42829 10.5141 3.42829 10.6691V11.1975C3.42829 11.3461 3.30599 11.4667 3.1399 11.4667H2.57383C2.41455 11.4667 2.28544 11.3525 2.28544 11.1975V10.6691ZM2.28544 8.53582C2.28544 8.38716 2.40774 8.26665 2.57383 8.26665H3.1399C3.29918 8.26665 3.42829 8.3808 3.42829 8.53582V9.06415C3.42829 9.21281 3.30599 9.33332 3.1399 9.33332H2.57383C2.41455 9.33332 2.28544 9.21916 2.28544 9.06415V8.53582ZM2.28544 6.40248C2.28544 6.25383 2.40774 6.13332 2.57383 6.13332H3.1399C3.29918 6.13332 3.42829 6.24747 3.42829 6.40248V6.93082C3.42829 7.07947 3.30599 7.19998 3.1399 7.19998H2.57383C2.41455 7.19998 2.28544 7.08583 2.28544 6.93082V6.40248Z'
			fill='#FFCD4B'
		/>
	</svg>
);

const Uk: React.FC = () => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<mask id='mask0_8524_2523' maskUnits='userSpaceOnUse' x='0' y='4' width='24' height='16'>
			<rect y='4' width='24' height='16' rx='2' fill='#FFF' />
		</mask>
		<g mask='url(#mask0_8524_2523)'>
			<path fillRule='evenodd' clipRule='evenodd' d='M0 12H24V4H0V12Z' fill='#156DD1' />
			<path fillRule='evenodd' clipRule='evenodd' d='M0 20H24V12H0V20Z' fill='#FFD948' />
		</g>
	</svg>
);

const En: React.FC = () => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<mask
			id='mask0_6103_31363'
			style={{ maskType: 'alpha' }}
			maskUnits='userSpaceOnUse'
			x='0'
			y='4'
			width='24'
			height='16'
		>
			<path
				d='M22 4H2C0.895431 4 0 4.89543 0 6V18C0 19.1046 0.89543 20 2 20H22C23.1046 20 24 19.1046 24 18V6C24 4.89543 23.1046 4 22 4Z'
				fill='white'
			/>
		</mask>
		<g mask='url(#mask0_6103_31363)'>
			<path d='M24 4H0V20H24V4Z' fill='#0A17A7' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5.72032 14.6666H-2.71797e-05V9.33329H5.72032L-2.37744 4.23541L-1.09929 2.4668L9.14283 8.91463V2.93329H14.8571V8.91463L25.0992 2.4668L26.3774 4.23541L18.2796 9.33329H24V14.6666H18.2796L26.3774 19.7645L25.0992 21.5331L14.8571 15.0853V21.0666H9.14283V15.0853L-1.09929 21.5331L-2.37744 19.7645L5.72032 14.6666Z'
				fill='white'
			/>
			<path d='M16.001 9.06578L26.857 2.40002' stroke='#DB1F35' strokeWidth='0.666667' strokeLinecap='round' />
			<path d='M17.1538 14.9581L26.8857 21.0803' stroke='#DB1F35' strokeWidth='0.666667' strokeLinecap='round' />
			<path d='M6.8621 9.04836L-3.28906 2.66321' stroke='#DB1F35' strokeWidth='0.666667' strokeLinecap='round' />
			<path d='M7.9631 14.8839L-3.28906 21.8484' stroke='#DB1F35' strokeWidth='0.666667' strokeLinecap='round' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0 13.6H10.2857V20H13.7143V13.6H24V10.4H13.7143V4H10.2857V10.4H0V13.6Z'
				fill='#E6273E'
			/>
		</g>
	</svg>
);

const Un: React.FC = () => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect y='4' width='24' height='16' rx='2' fill='#418FDE' />
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M11.6846 16.8991C11.7889 16.9057 11.894 16.9091 12 16.9091C12.106 16.9091 12.2111 16.9057 12.3154 16.8991C13.0645 16.0119 13.545 14.3856 13.6246 12.5455H10.3754C10.455 14.3856 10.9355 16.0119 11.6846 16.8991ZM10.1858 16.563C9.65395 15.4797 9.34323 14.0684 9.28338 12.5455H7.12087C7.32339 14.3775 8.53407 15.9057 10.1858 16.563ZM11.6846 7.10088C10.9355 7.9881 10.455 9.61442 10.3754 11.4545H13.6246C13.545 9.61442 13.0645 7.9881 12.3154 7.10088C12.2111 7.09427 12.106 7.09091 12 7.09091C11.894 7.09091 11.7889 7.09427 11.6846 7.10088ZM10.1858 7.43702C8.53407 8.0943 7.32339 9.6225 7.12087 11.4545H9.28338C9.34323 9.93161 9.65395 8.52031 10.1858 7.43702ZM13.8142 16.563C15.4659 15.9057 16.6766 14.3775 16.8791 12.5455H14.7166C14.6568 14.0684 14.346 15.4797 13.8142 16.563ZM13.8142 7.43702C14.346 8.52031 14.6568 9.93161 14.7166 11.4545H16.8791C16.6766 9.6225 15.4659 8.0943 13.8142 7.43702ZM12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18Z'
			fill='white'
		/>
	</svg>
);

const Tr: React.FC = () => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<mask
			id='mask0_2936_64272'
			style={{ maskType: 'alpha' }}
			maskUnits='userSpaceOnUse'
			x='0'
			y='4'
			width='24'
			height='16'
		>
			<path
				d='M22 4H2C0.895431 4 0 4.89543 0 6V18C0 19.1046 0.89543 20 2 20H22C23.1046 20 24 19.1046 24 18V6C24 4.89543 23.1046 4 22 4Z'
				fill='white'
			/>
		</mask>
		<g mask='url(#mask0_2936_64272)'>
			<path d='M24 4H0V20H24V4Z' fill='#E92434' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16.0166 12.65L14.6731 13.5439L15.1688 12.0751L13.8428 11.1587L15.4926 11.1449L16.0166 9.68463L16.5406 11.1449L18.1905 11.1587L16.8644 12.0751L17.3601 13.5439L16.0166 12.65Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M14.9167 9.05272C14.1905 8.5601 13.2775 8.26668 12.2858 8.26668C9.91885 8.26668 8.00007 9.93815 8.00007 12C8.00007 14.0619 9.91885 15.7333 12.2858 15.7333C13.2775 15.7333 14.1905 15.4399 14.9167 14.9473C13.9757 16.0748 12.5072 16.8 10.8572 16.8C8.01689 16.8 5.71436 14.651 5.71436 12C5.71436 9.34905 8.01689 7.20001 10.8572 7.20001C12.5072 7.20001 13.9757 7.92521 14.9167 9.05272Z'
				fill='white'
			/>
		</g>
	</svg>
);

const FlagIcon: React.FC<FlagProps> = ({ lang }) => {
	switch (lang) {
		case 'ru':
			return isHiddenRuFlag ? <RuNoFlag /> : <Ru />;
		case 'kz':
			return <Kz />;
		case 'uk':
			return <Uk />;
		case 'un':
			return <Un />;
		case 'tr':
			return <Tr />;
		case 'en':
			return <En />;
		default:
			return null; // Return null for unsupported languages
	}
};

export default FlagIcon;
